import { Story } from "./game";
const bucketName = "murderhungrystories190715-dev";

export const getImg = (story: Story): string => {
    const url = `https://${bucketName}.s3.amazonaws.com/public/${story.cover}`;
    return url;
  };